import { useFormik } from 'formik'
import { useState } from 'react'
import { NumericFormat } from 'react-number-format'
import { parseCurrencyToNumber } from '../../helpers'
import { useUpdateCreatorSplitMutation } from '../../redux-toolkits/vendors/vendors.slice'
import { Vendor } from '../../redux-toolkits/vendors/vendors.types'
import { VendorSplitConfigurationSchema } from '../../validation/validate'
import { Checkbox } from '../inputs/Checkbox'
import { EditInput } from '../inputs/editInput'
import { TextInput } from '../inputs/textInput'

export const VendorSplitConfigiration = ({
  vendor,
  className = '',
  refetch,
}: {
  vendor?: Vendor
  className?: string
  refetch: () => void
}) => {
  const [editing, setEditing] = useState(false)

  const [updateVendorSplit, { isLoading: updatingVendorSplit }] =
    useUpdateCreatorSplitMutation()

  const {
    values,
    setFieldValue,
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
  } = useFormik({
    initialValues: {
      splitPercentage: vendor?.splitPercentage
        ? vendor.splitPercentage * 100
        : undefined,
      isSplitEnabled: vendor?.isSplitEnabled ?? false,
    },
    enableReinitialize: true,
    validationSchema: VendorSplitConfigurationSchema,
    onSubmit: async (vals) => {
      const resp = await updateVendorSplit({
        id: vendor?._id ?? '',
        payload: {
          splitPercentage: vals.isSplitEnabled
            ? parseCurrencyToNumber(vals?.splitPercentage) ?? 0
            : undefined,
          isSplitEnabled: vals?.isSplitEnabled ?? false,
        },
      })

      if (resp.data?.success) {
        refetch()
        setEditing(false)
      }
    },
  })

  return (
    <div className={className}>
      <EditInput
        onEditSave={() => {
          handleSubmit()
        }}
        editing={editing}
        onEditClick={() => {
          setEditing(true)
        }}
        onCancel={() => {
          setEditing(false)
        }}
        title="Split Configuration"
        loading={updatingVendorSplit}
      >
        {({ isEditing }) => {
          return isEditing ? (
            <div className="w-full flex flex-col gap-6">
              <Checkbox
                checkStatus={!!values.isSplitEnabled}
                handleChange={(status) => {
                  setFieldValue('isSplitEnabled', status)
                }}
                text="Enable split for this creator?"
              />

              {values.isSplitEnabled && (
                <div className="flex flex-col gap-4 first:pt-0">
                  <NumericFormat
                    suffix={'%'}
                    prefix={undefined}
                    customInput={TextInput}
                    type="text"
                    name="splitPercentage"
                    placeholder="Enter percentage"
                    value={values.splitPercentage}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    errors={
                      errors.splitPercentage && touched.splitPercentage
                        ? errors.splitPercentage
                        : ''
                    }
                    hasIcon={false}
                    decimalScale={2}
                    thousandSeparator
                  />
                </div>
              )}
            </div>
          ) : (
            <div>
              {vendor?.isSplitEnabled ? 'Enabled' : 'Disabled'}{' '}
              {vendor?.splitPercentage && vendor?.isSplitEnabled
                ? `• ${vendor?.splitPercentage * 100}%`
                : undefined}
            </div>
          )
        }}
      </EditInput>
    </div>
  )
}
